import View from "../../View";
import {breakpoint} from "../../utils/dom";
import animateScrollTo from 'animated-scroll-to';

/**
 * Toc
 */
class Toc extends View {
  /**
   * Toc constructor
   * @param node
   */
  constructor(node) {
    super(node);

    this.scrollToOptions = {
      minDuration: 400,
      maxDuration: 800,
      horizontalOffset: -100,
      verticalOffset: -80,
    };
    if (breakpoint("large-down")) {
      //First TOC element has a weird offset
      this.scrollToOptions.verticalOffset = -40;
    }

    //Get all the clickable links in the TOC
    this.links = Array.from(this.node.querySelectorAll(".js-toc-link"));
    this.tocHeaderButton = this.node.querySelector(".js-toc-header");
    this.tocList = this.node.querySelector(".js-toc-list");
    this.pageHeader = document.querySelector(".js-header");
    this.aside = document.querySelector(".js-article-aside");
    this.footer = document.querySelector(".js-footer");

    this.bango = document.getElementById("bango");

    //on click header button open toc list
    this.tocHeaderButton.addEventListener("click", e => {
      //only on screens smaller than large
      if (breakpoint("large-down")) {
        this.toggleTocList(e);
      }
    });

    //If we have links, attach an event listener to all of them
    if (this.links) {
      this.links.forEach(link => {
        link.addEventListener("click", this.linkClickHandler);
      });
    }

    //Store header positions on page load
    document.addEventListener("DOMContentLoaded", this.onLoad);

    //Scroll handler to make toc items active when around them
    document.addEventListener("scroll", this.scrollHandler);

    this.makeTocSticky();
    this.makeTocStickyToBottom(node);

    this.scrollHandler();

    events.on("resize", this.resetWaypoints);
  }

  onLoad(){
    //If we have headers to link to, store all of their positions
    this.headers = Array.from(document.querySelectorAll(".js-article-header"));
    this.headerPositions = {};
    if (this.headers) {
      this.headers.forEach(header => {
        let classList = header.classList;

        if (!classList) {
          return;
        }

        classList = Array.from(classList);

        //Attempt to get the className for the header which we need (js-toc-...)
        let className = "";
        classList.forEach(classListItem => {
          if (classListItem.indexOf("js-toc-") !== -1) {
            className = classListItem;
          }
        });

        if (className === "") {
          return;
        }

        let headerBounds = header.getBoundingClientRect();

        //Store the position of the header to scroll to
        this.headerPositions[className] =
          headerBounds.top + document.documentElement.scrollTop;
      });
      window.sessionStorage.setItem("headerLocations", JSON.stringify(this.headerPositions));
    }
  }

  /**
   * Toggle the TOC list open and closed (only on mobile/tablet)
   * @param e
   */
  toggleTocList = e => {
    e.currentTarget.classList.toggle("active");
    this.tocList.classList.toggle("open");
  };

  /**
   * Scroll to the associated header when clicked
   * @param e
   */
  linkClickHandler = e => {
    this.headerPositions = JSON.parse(window.sessionStorage.getItem("headerLocations"));
    const url = e.currentTarget.dataset.url.replace("#", "");
    const className = "js-toc-" + url;
    const header = this.headerPositions.hasOwnProperty(className)
      ? this.headerPositions[className]
      : false;

    //Scroll to the header if it was found
    if (header !== false) {

      //Scroll To
      const scrollToElement = document.querySelector('.' + className);

      let options = this.scrollToOptions;
      if (url === 'author-info') options.verticalOffset += -30;

      animateScrollTo(scrollToElement, options).then(hasScrolledToPosition => {
        if (hasScrolledToPosition) {
          //Toggle header
          this.tocHeaderButton.click();
        }
      });
    }
  };

  /**
   * Make the toc sticky
   */
  makeTocSticky = () => {
    const offset = this.pageHeader.clientHeight + 20;

    let widthOffset =
      Math.max(document.documentElement.clientWidth, window.innerWidth || 0) >
      1380
        ? 0
        : 30;

    new Waypoint({
      element: this.aside,
      offset: offset,
      handler: function () {
        this.node.classList.toggle("visible");
        document.body.classList.toggle("sticky-toc");
        events.emit("stickyHeaderToggle");
        this.node.style.maxWidth = this.aside.offsetWidth - widthOffset + "px";
      }.bind(this)
    });
  };

  /**
   * Make the toc sticky to bottom after scrolling footer in frame
   */
  makeTocStickyToBottom = () => {
    let pageOffset = 125; // offset of header, paddings etc
    let tocOffset = window.innerHeight - this.node.offsetHeight; //difference
                                                                 // between toc
                                                                 // height and
                                                                 // window
                                                                 // height
    let waypointOffset = window.innerHeight - tocOffset + pageOffset; //pixels
                                                                      // from
                                                                      // top
                                                                      // the
                                                                      // toc is
                                                                      // located

    new Waypoint({
      element: this.footer,
      offset: waypointOffset, // react when element is offset px from top of
                              // page
      handler: function () {
        this.node.classList.toggle("sticky-toc-bottom");
      }.bind(this)
    });
  };

  /**
   * Make the toc sticky to bottom after scrolling footer in frame
   */
  resetWaypoints = () => {
    Waypoint.refreshAll();
  };

  /**
   *
   * @param e
   */
  scrollHandler = e => {
    let currentScrollTop =
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ||
      window.navigator.userAgent.indexOf("Edge") > -1
        ? document.querySelector("body").scrollTop
        : document.documentElement.scrollTop;
    // Above regex doesn't seem to be working on all Safari versions
    if (currentScrollTop === 0 && document.documentElement.scrollTop !== 0) {
      currentScrollTop = document.documentElement.scrollTop;
    }

    let activeHeaderClassName = false;

    this.headerPositions = JSON.parse(window.sessionStorage.getItem("headerLocations"));

    for (let headerClassName in this.headerPositions) {
      if (
        this.headerPositions.hasOwnProperty(headerClassName) &&
        this.headerPositions[headerClassName] -
        30 -
        this.pageHeader.clientHeight <
        currentScrollTop
      ) {
        activeHeaderClassName = headerClassName;
      }
    }

    if (activeHeaderClassName !== false) {
      this.makeTocLinkActive(activeHeaderClassName);
    }
  };

  /**
   * Make a TOC link active based on a header className
   * @param headerClassName
   */
  makeTocLinkActive = headerClassName => {
    let activeLink = document.querySelector(".toc-link.active");

    if (activeLink) {
      activeLink.classList.remove("active");
    }

    if (headerClassName === false) {
      return;
    }
    if (headerClassName.indexOf("'") !== -1) {
      return;
    }
    let targetLink = this.node.getElementsByClassName(`${headerClassName}`);

    if (targetLink) {
      targetLink[0].classList.add("active");
    }
  };
}

export default Toc;



// WEBPACK FOOTER //
// frontend/js/components/navigation/Toc.js